import {ListItem} from '../list/list_item.tsx';
import {Icon} from '../icon/icon.tsx';
import listStyles from '../list/list.module.scss';
import {LocationType} from '../../gql/customer/graphql.ts';
import {Spacer} from '../utility/spacer.tsx';
import {Radio} from '../radio/radio.tsx';

interface OwnProps {
    location: LocationType | null;
    selectedLocationId?: number | null;
    onClick: (locationId: number) => void;
}

export function LocationSelectListItem({location, selectedLocationId, onClick}: OwnProps) {
    if (!location) {
        return null;
    }

    const onItemClick = () => {
        if (onClick !== undefined && location.id != null) {
            onClick(location.id);
        }
    };

    return (
        <ListItem onClick={() => onItemClick()}>
            <div className={listStyles.list__item_content}>
                <Radio
                    disabled={false}
                    name={`vehicle_${location.id}`}
                    label={''}
                    defaultChecked={location.id === selectedLocationId}
                />
                <Icon src={location.photo_url ?? ''} />
                <Spacer />
                <span>{location.name}</span>
            </div>
        </ListItem>
    );
}
